import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

export const TaskIcon = () => <AssignmentTurnedInIcon />;
